import React, { useState } from 'react';

export default function AdminBackfill() {
  const [pageSize, setPageSize] = useState(50);
  const [maxPages, setMaxPages] = useState(20);
  const [startBefore, setStartBefore] = useState('');
  const [status, setStatus] = useState('');
  const [busy, setBusy] = useState(false);

  const headers = {
    'Content-Type': 'application/json',
    'X-API-Key': (process.env.REACT_APP_SOULWARS_API_KEY || 'dev-key')
  };

  const runSolanaBackfill = async () => {
    setBusy(true);
    setStatus('Starting backfill...');
    try {
      const body = {
        pageSize: Number(pageSize) || 50,
        maxPages: Number(maxPages) || 20,
        ...(startBefore ? { startBefore } : {})
      };
      const res = await fetch('/api/ledger/backfill/solana', {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
      });
      const json = await res.json();
      if (res.ok) setStatus('Backfill completed successfully.');
      else setStatus(`Backfill failed: ${json?.error || 'unknown error'}`);
    } catch (e) {
      setStatus(`Backfill error: ${e?.message || e}`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ padding: 16 }}>
      <h2>Ledger Backfill</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 620 }}>
        <div style={{ display: 'flex', gap: 8 }}>
          <label>Page Size</label>
          <input type="number" value={pageSize} onChange={e => setPageSize(e.target.value)} />
          <label>Max Pages</label>
          <input type="number" value={maxPages} onChange={e => setMaxPages(e.target.value)} />
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <label>Start Before (signature)</label>
          <input style={{ width: 420 }} value={startBefore} onChange={e => setStartBefore(e.target.value)} placeholder="optional" />
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button disabled={busy} onClick={runSolanaBackfill}>Run Solana Backfill</button>
        </div>
        <div style={{ marginTop: 8, minHeight: 24 }}>{status}</div>
      </div>
    </div>
  );
}


